export function isEmpty(text: string | undefined | null) {
    return text === null || text === undefined || text.length === 0;
}

export function isNonEmptyString(text: unknown): text is string {
    if (typeof text === 'string') {
        return !isEmpty(text);
    }

    return false;
}

export function capitalizeFirstLetter(stringToCapitalize: string) {
    return stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1);
}

export function stripWhiteSpace(text: string) {
    return text.replace(/\s/g, '');
}
